/** Поле вокруг картинки на холсте разметки — чтобы вершину полигона можно было
 *  вынести ЗА границу кадра (Алексей 23.09, AI167: у Astra правый нижний угол
 *  стеллажа «Выпечка» упирается в край, и полигон нельзя сделать прямоугольным
 *  в перспективе). Доля от размера картинки, одинаковая по обеим осям, поэтому
 *  нормированные координаты точек лежат в [-POLYGON_OVERSHOOT, 1 + POLYGON_OVERSHOOT].
 *  Бэкенд координаты не валидирует; перспективный кроп (getPerspectiveTransform)
 *  с точками вне кадра работает — область за кадром уходит в чёрное. */
export const POLYGON_OVERSHOOT = 0.15;

/** Ширина поля в пикселях картинки (не экрана) по каждой оси. */
export function gutterPx(imageSize: { width: number; height: number }): { x: number; y: number } {
  return { x: imageSize.width * POLYGON_OVERSHOOT, y: imageSize.height * POLYGON_OVERSHOOT };
}

/** Размер картинки вместе с полем — это и есть размер Stage до масштабирования. */
export function stageSizePx(imageSize: { width: number; height: number }): { width: number; height: number } {
  const g = gutterPx(imageSize);
  return { width: imageSize.width + 2 * g.x, height: imageSize.height + 2 * g.y };
}

/** Нормированная координата с допуском поля. */
export function clampOvershoot(value: number): number {
  return Math.max(-POLYGON_OVERSHOOT, Math.min(1 + POLYGON_OVERSHOOT, value));
}
